import axios from "./axios";

export const getCostData = async (params) => {
  try {
    const data = await axios.post(`/api/v1/provision/costexplorer?startdate=${params.startdate}&enddate=${params.enddate}&granularity=${params.granularity}&format=json`, params.meta);
    return data;
  } catch (error) {
    console.log("Failed to get cost data:" + error);
    return {
      "Title": "None",
      "Fields": [],
      "TotalCol": [],
      "Dates": []
    }
  }
};

/**response ["granularity", "groupby", "filter"] */
export const getCostOptions = async () => {
  try {
    const data = await axios.get(`/api/v1/provision/costexplorer`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

/** key=granularity, response ["Daily", "Monthly"] 
 *  key=groupby , response ["None", "Service", "Region", "Instance type", "Tag"]
 *  key=filter, response ["Service", "Region", "Instance type", "Tag"]*/
export const getCostOptionValues = async (key) => {
  try {
    const data = await axios.get(`/api/v1/provision/costexplorer?option=${key}`);
    return data;
  } catch (error) {
    console.log("Failed to get cost option - granularity:" + error);
    return [];
  }
};

/** response ["All", "vtTenant", "vtShareID", "vtInstanceID", "vtInstanceName", "vtResourceType", "vtShareName", "vtShareType"] */
export const getCostGroupByTags = async () => {
  try {
    const data = await axios.get(`/api/v1/provision/costexplorer?option=groupby&optionname=Tag`);
    return data;
  } catch (error) {
    console.log("Failed to get cost groupby tags:" + error);
    return [];
  }
};

/** optName can be "Service", "Region", "Instance type", "Tag" */
export const getCostFilterOptions = async (optName) => {
  try {
    const data = await axios.get(`/api/v1/provision/costexplorer?option=filter&optionname=${optName}`);
    return data;
  } catch (error) {
    console.log(`Failed to get cost filter options for : ${optName}` + error);
    return [];
  }
};

export const getCostFilterTagValues = async (optValue) => {
  try {
    const data = await axios.get(`/api/v1/provision/costexplorer?option=filter&optionname=Tag&optionvalue=${optValue}`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};
export const downloadCost = async (params) => {
  try{
    const data = await axios.post(`/api/v1/provision/costexplorer?startdate=${params.startdate}&enddate=${params.enddate}&granularity=${params.granularity}&format=csv`, params.meta);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};
